import cx from "classnames";

import Box, { BoxProps } from "../../Box";
import styles from "./styles.module.css";

type ActionCardContentProps = BoxProps;

const ActionCardContent = ({ className, ...props }: ActionCardContentProps) => {
  const contentClass = cx(styles.content, className);

  return <Box fullWidth direction="column" className={contentClass} {...props} />;
};

ActionCardContent.displayName = "DS.ActionCard.Content";

export default ActionCardContent;
